<script lang="ts" setup>
import NewMobileMenu from "~/components/menus/NewMobileMenu.vue";
import { useMobileMenuStore } from '~/store/mobile-menu'

const mobileMenuStore = useMobileMenuStore()
const { isShowMobileMenu } = storeToRefs(mobileMenuStore)
</script>

<template>
  <div
    class="
      sticky top-0 z-[1000] border-b border-main-gray bg-[#f5f5f5] py-[calc(0.75rem-0.5px)]
      md:py-[calc(1.25rem-0.5px)]
    "
  >
    <Container class="px-3">
      <div class="flex items-center justify-between">
<!--        <div class="order-1 md:order-3">-->
<!--        </div>-->

        <Logo class="!max-h-[22px] !max-w-[77px] md:!max-h-[36px] md:!max-w-[107px]" />

        <Burger class="md:hidden" :is-open="isShowMobileMenu" @click="mobileMenuStore.toggleMobileMenu" />
      </div>
    </Container>

    <Transition>
      <NewMobileMenu
        v-show="isShowMobileMenu"
        class="!top-[49px] !h-[calc(100vh-49px)]"
        @closing="mobileMenuStore.closeMobileMenu"
      />
    </Transition>
  </div>
</template>
